import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';

export type AlertType = 'info' | 'warning' | 'error' | 'success';

interface AlertConfig {
  icon: string;
  containerClasses: string;
}

const ALERT_CONFIGS: Record<AlertType, AlertConfig> = {
  info: {
    icon: 'info',
    containerClasses: 'bg-blue-500/10 border-blue-500/20 text-blue-300',
  },
  warning: {
    icon: 'warning',
    containerClasses: 'bg-amber-500/10 border-amber-500/20 text-amber-300',
  },
  error: {
    icon: 'error',
    containerClasses: 'bg-red-500/10 border-red-500/20 text-red-300',
  },
  success: {
    icon: 'check_circle',
    containerClasses: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-300',
  },
};

@Component({
  selector: 'sortaify-alert',
  standalone: true,
  imports: [MatIconModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class SortAlertComponent {
  @Input() type: AlertType = 'info';
  @Input() dismissible = false;
  @Output() dismissed = new EventEmitter<void>();

  get config(): AlertConfig {
    return ALERT_CONFIGS[this.type];
  }

  getIcon(): string {
    return this.config.icon;
  }

  getContainerClasses(): string {
    return this.config.containerClasses;
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}